import React from 'react'
import {
    schedules,
    updateSchedule,
    invokeSchedule,
    testInvokeInvoiceDirectSchedule,
    testInvokeInvoiceIndirectSchedule,
    getGracePeriod,
    testGeneratePastInvoices,
    testGeneratePastFiscalReportsImport,
    testGeneratePastFiscalReportsNonEuGB,
    testGeneratePastFiscalReportsNonUnion, testGeneratePastFiscalReportsUnion
} from "../api/api";
import moment from "moment-timezone";
import {Button, Divider, Modal, notification, Select, Space, DatePicker} from 'antd'
import {
    DeleteOutlined,
    EditOutlined,
    CaretRightOutlined,
    BackwardOutlined
} from "@ant-design/icons"
import {CronSelector} from "@q4us-sw/q4us-ui/lib/CronSelector";
import {TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {Header} from "./generic/Header";
import {DefaultProps} from "./RefTable";
import PropTypes from "prop-types";


export const ActionMap = {
    "Generate EM Invoice - Indirect": process.env.REACT_APP_DEMO_MODE ? testInvokeInvoiceIndirectSchedule : invokeSchedule,
    "Generate EM Invoice Direct": process.env.REACT_APP_DEMO_MODE ? testInvokeInvoiceDirectSchedule: invokeSchedule,
    "*": invokeSchedule
}


export const Schedules = (props)=>{

    const [gracePeriod,setGracePeriod] = React.useState();
    const [schedule,setSchedule] = React.useState();

    const load = React.useCallback(async (filters, page)=>{
        return await props.fetch("schedules", filters, page);
    }, [props])

    const triggerDisabled = React.useCallback((row)=>{
        switch(row.name){
            case "Generate EM Invoice - Indirect":
            case "Generate EM Invoice Direct":
            case "Generate EM VAT Report - FISCAL - IMPORT": {
                let date = new Date();
                return (!process.env.REACT_APP_DEMO_MODE) && (new Date(date.getFullYear(), date.getMonth(), 1).getUTCDate() + parseInt(gracePeriod) + 2) > date.getUTCDate()
            }
            default:
                return false
        }
    },[gracePeriod])

    React.useEffect(()=>{
        getGracePeriod().then(({data})=>{
            setGracePeriod(data);
        })
    },[])

    return <React.Fragment>
        <TableV2
            schema={"schedules"}
            shouldRefresh={(operation, status) => {
                return operation === TableOperation.Update
            }}
            fetchConfig={async ()=>props.tableConfigs()}
            rowKey={"id"}
            scroll={{y: `calc(100vh - 134px - ${(props.theadHeight + props.tfootHeight)}px)`, x: 'max-content'}}
            fetchData={async (request) => {
                return load(request.options.filter || {}, request.page);
            }}
            saveData={async (data) => {}}
            header={
                <Header title={"Schedules"} />
            }
            customRenderer={{
                id: (value, row, index, column, editable) =>{
                    return <Space size={0}>
                        <Button disabled={triggerDisabled(row)} icon={<CaretRightOutlined />} onClick={async ()=>{
                            let resp = ActionMap.hasOwnProperty(row.name) ? await ActionMap[row.name](row) : await ActionMap["*"](row)
                            if (resp) {
                                const {data: {message}} = resp;
                                notification.success({message})
                            }
                        }}/>
                        {process.env.REACT_APP_DEMO_MODE && row.action === 'persistence.persistInvoice' && <PastInvoices em_type={row.variables.em_type}/>}
                        {process.env.REACT_APP_DEMO_MODE && row.action === 'persistence.generateEMVATReportsFiscalImport' && <PastReports report_type='import'/>}
                        {process.env.REACT_APP_DEMO_MODE && row.action === 'persistence.generateEMVATReportsFiscalNonEUGB' && <PastReports report_type='non_eu_gb'/>}
                        {process.env.REACT_APP_DEMO_MODE && row.action === 'persistence.generateEMVATReportsFiscalNonUnion' && <PastReports report_type='non_union'/>}
                        {process.env.REACT_APP_DEMO_MODE && row.action === 'persistence.generateEMVATReportsFiscalUnion' && <PastReports report_type='union'/>}
                        <Button icon={<EditOutlined  onClick={()=>{
                            setSchedule(row);
                        }}/>}/>
                        <Button disabled={true} className="ant-btn-danger" icon={<DeleteOutlined />}/>
                    </Space>
                }
            }}
        >

        </TableV2>
        <Modal
            key={schedule?.name || "default"}
            visible={schedule != null}
            centered={true}
            width={720}
            onOk={async ()=>{
                //save
                const {data:{message} = {}} = await updateSchedule(schedule)
                if(message){
                    notification.success({message});
                }
                setSchedule(undefined)
            }}
            onCancel={()=>{
                setSchedule(undefined)
            }}
        >
            <Space direction={"vertical"}>
                <Select showSearch optionFilterProp={'children'} style={{minWidth: 250}} value={schedule ? schedule.timezone : undefined} onChange={(e)=>{
                    setSchedule({...schedule, timezone: e})
                }}>
                    {
                        moment.tz.names().map(o=><Select.Option value={o}>{o}</Select.Option>)
                    }
                </Select>
                <Divider/>
                <CronSelector value={schedule ? schedule.cron_time : '0 0 * * *'} onChange={(data)=>{
                    setSchedule({...schedule, cron_time: data})
                }}/>
            </Space>
        </Modal>

    </React.Fragment>
}

export const columns = [
    {name: "name", type: "STRING", title: "Name" },
    {name: "nextDate", type: "STRING", title: "Next Run" },
    {name: "last_run", type: "STRING", title: "Last Run" },
    {name: "timezone", type: "STRING", title: "Timezone" },
    {name: "action", type: "STRING", title: "Action" },
    {name: "id", type: "STRING", title: "" },
];

export const PastInvoices = ({em_type}) => {

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState();

    const disabledDate = (current) => {
        // Can not select days after today
        return current > new Date();
    };

    const onChange = (date, dateString) => {
        setSelectedDate(dateString)
    };
    return <React.Fragment>
        <Button icon={<BackwardOutlined onClick={()=>{
            setIsModalOpen(true);
        }}/>}/>
        <Modal
            title={'Generate Past Invoices'}
            visible = {isModalOpen}
            okText={'Submit'}
            onOk={async ()=>{
                //generate past invoices
                const {data = {}} = await testGeneratePastInvoices({invoice_date: selectedDate, payment_mode: em_type})
                if(data){
                    notification.success({message: 'Past invoices generated successfully'});
                }
                setIsModalOpen(false)
            }}
            onCancel={()=>{
                setIsModalOpen(false)
            }}>
        <Space direction="vertical" align={'center'}>
            <DatePicker onChange={onChange} picker="month" disabledDate={disabledDate} format={'YYYY-MM-DD'}/>
        </Space>

        </Modal>

    </React.Fragment>

}

export const PastReports = ({report_type}) => {

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState();

    const disabledDate = (current) => {
        // Can not select days after today
        return current > new Date();
    };

    const onChange = (date, dateString) => {
        setSelectedDate(dateString)
    };
    return <React.Fragment>
        <Button icon={<BackwardOutlined onClick={()=>{
            setIsModalOpen(true);
        }}/>}/>
        <Modal
            title={'Generate Past Reports'}
            visible = {isModalOpen}
            okText={'Submit'}
            onOk={async ()=>{
                //generate past invoices
                let data = null;
                if (report_type === 'import') {
                    data = await testGeneratePastFiscalReportsImport({date: selectedDate})
                } else if (report_type === 'non_eu_gb') {
                    data = await testGeneratePastFiscalReportsNonEuGB({date: selectedDate})
                } else if (report_type === 'non_union') {
                    data = await testGeneratePastFiscalReportsNonUnion({date: selectedDate})
                } else if (report_type === 'union') {
                    data = await testGeneratePastFiscalReportsUnion({date: selectedDate})
                }
                if(data){
                    notification.success({message: 'Past reports generated successfully'});
                }
                setIsModalOpen(false)
            }}
            onCancel={()=>{
                setIsModalOpen(false)
            }}>
            <Space direction="vertical" align={'center'}>
                <DatePicker onChange={onChange} picker="month" disabledDate={disabledDate} format={'YYYY-MM-DD'}/>
            </Space>

        </Modal>

    </React.Fragment>

}

Schedules.propTypes = {
    tableConfigs: PropTypes.func
}

Schedules.defaultProps = {
    ...DefaultProps,
    tableConfigs: async (schema)=>({data: {statusCode: 200, rows: columns}}),
    fetch: async (tableName, filters = {}, page = {})=>schedules()
}
